_ = require('lodash')

module.exports = (
  $interpolate,
  User,
)->
  return {
    restrict: 'A'
    template: require('./tagging-toolbar.html')
    scope:
      isDisabled: '&taggingToolbarIsDisabled'
      getTags: '&taggingToolbarGetTags'
      saveTags: '&taggingToolbarSaveTags'
      taggingConfig: '&taggingToolbarConfig'
      resultNumber: '=taggingToolbarResultNumber'
      getIsSelected: '&taggingToolbarGetIsSelected',
      setIsSelected: '&taggingToolbarSetIsSelected',
      openEntityModal: '&taggingToolbarOpenEntityModal',
      isDispositioned: '&taggingToolbarIsDispositioned',
      getStarredDocument: '&taggingToolbarGetStarredDocument',

    link: ( $scope ) ->
      EMPTY_ARRAY = []

      $scope.chooseOption = (option, tagGroup) ->
        optionWasChosen = !!option
        shouldIncludeId = optionWasChosen and not option.exclude

        if tagGroup.displayType == 'Checkbox'
          newIds = $scope.getTags()
          if shouldIncludeId
            if newIds.indexOf(option.id) == -1
              newIds.push(option.id)
            else
              newIds = newIds.filter((id) -> id != option.id)
          $scope.saveTags({tagIds: getValidTagIdsToSave(newIds)})
        else
          tagsGroupTagIds = _.map(tagGroup.options, 'id')
          documentTagIdsWithoutTagsInCurrentGroup = _.reject($scope.getTags(), (documentTagId) -> _.contains(tagsGroupTagIds, documentTagId))

          newTag = if shouldIncludeId then [option.id] else []
          allIds = documentTagIdsWithoutTagsInCurrentGroup.concat(newTag)

          documentTagIdsToSave = getValidTagIdsToSave(allIds)
          $scope.saveTags({tagIds: documentTagIdsToSave})

      # It's often easier to work with tag objects rather than the tag IDs
      taggingConfig = $scope.taggingConfig() or User.getTaggingConfig('standard')
      taggingConfig = _.cloneDeep(taggingConfig)
      _.each(taggingConfig.config.groups, (group) ->
        options = if 'options' of group then group.options else group.tags
        group.options = _.map(options, (objOrId) ->
          isObj = objOrId instanceof Object
          tagId = if not isObj then objOrId else objOrId.tag
          tagObj = _.find(taggingConfig.tags, 'id', tagId)
          hasSubGroup = isObj and 'subGroup' of objOrId
          subGroup = {subGroup: if hasSubGroup then objOrId.subGroup else ''}
          hasIconClass = isObj and 'iconClass' of objOrId
          iconClass = {iconClass: if hasIconClass then objOrId.iconClass else ''}
          hasIconStyle = isObj and 'iconStyle' of objOrId
          iconStyle = {iconStyle: if hasIconStyle then objOrId.iconStyle else {}}
          hasLabel = isObj and 'label' of objOrId
          label = {label: if hasLabel then objOrId.label else tagObj.name}
          shouldExclude = isObj and 'exclude' of objOrId and objOrId.exclude
          exclude = {exclude: shouldExclude}
          _.merge({}, tagObj, subGroup, iconClass, iconStyle, label, exclude)
        )
        group.label = if group.displayName? then $interpolate(group.displayName)({resultNumber: $scope.resultNumber}) else ''
      )

      getTagGroup = (tagId) ->
        return _.first(_.where(taggingConfig.config.groups, {options: [{id: tagId}]}))

      isTagGroupVisible = (tagGroup) ->
        selectedTagIds = $scope.getTags()
        return isTagGroupVisibleBasedOnSelected(selectedTagIds, tagGroup)

      isTagGroupVisibleBasedOnSelected = (selectedTagIds, tagGroup) ->
        if not ('condition' of tagGroup)
          return true

        tagsAny = tagGroup.condition.tagsAny or EMPTY_ARRAY
        return _.any(selectedTagIds, (selectedTagId) -> _.contains(tagsAny, selectedTagId))

      #Return only valid tag ids.
      getValidTagIdsToSave = (allIdsToBeSaved) ->
        currentResult = allIdsToBeSaved
        prevResult = []
        while not _.eq(prevResult, currentResult)
          prevResult = currentResult
          currentResult = _.filter(currentResult, (tagId) ->
            tagIdGroup = getTagGroup(tagId)
            isTagGroupVisibleBasedOnSelected(currentResult, tagIdGroup)
          )

        return prevResult

      $scope.visibleTagGroups = () ->
        return _.filter(taggingConfig.config.groups, isTagGroupVisible)

      $scope.getTagGroupClass = ->
        if $scope.visibleTagGroups().length == 1
          return 'col-xs-12'
        else
          return 'col-md-3'

      $scope.isBulkTaggingEnabled = () ->
        User.bulk_tagging_enabled

      $scope.userCanAddEntities = () ->
        User.hasPermission('workflow.add_entity', false)

      # ng-model will set `isSelected`, but this is actually needless
      # because the (necessary) watcher will set it as long as somewhere
      # up the chain getIsSelelected will be made to return the right
      # thing
      $scope.model = {
        isSelected: $scope.getIsSelected()
      }

      $scope.$watch $scope.getIsSelected, (isSelected) ->
        $scope.model.isSelected = isSelected
  }
